export const TAB_ALL_ID = 'all';

export const FocusCountId = {
  AT_RISK: 'at_risk',
  UPSELL: 'upsell',
  RENEWAL: 'renewal',
};

export const DEFAULT_COLOR_CLASS = 'muted';

export const FOCUS_CARD_DEFINITIONS = [
  { id: 'at_risk', filterId: 'at_risk', badgeColor: 'danger', accentColor: '#ff5a4d' },
  { id: 'renewal_due', filterId: 'renewal', badgeColor: 'warning', accentColor: '#ff9f1c' },
  { id: 'upsell_ready', filterId: 'upsell', badgeColor: 'success', accentColor: '#3ecf6d' },
  { id: 'healthy', filterId: 'healthy', badgeColor: 'info', accentColor: '#2684ff' },
];

export const TAB_DEFINITIONS = [
  { id: TAB_ALL_ID, color: 'neutral' },
  { id: 'at_risk', countKey: 'at_risk', color: 'danger' },
  { id: 'renewal', countKey: 'renewal', color: 'warning' },
  { id: 'upsell', countKey: 'upsell', color: 'success' },
];

// Keyed by the status identifier returned from the API
export const STATUS_CONFIG = {
  at_risk: { colorClass: 'danger', filterKey: 'at_risk' },
  renewing: { colorClass: 'warning', filterKey: 'renewal' },
  upsell: { colorClass: 'success', filterKey: 'upsell' },
  healthy: { colorClass: 'info', filterKey: 'healthy' },
};

// Keyed by the action identifier returned from the API
export const ACTION_CONFIG = {
  prep_renewal_brief: { colorClass: 'danger' },
  build_renewal_deck: { colorClass: 'warning' },
  build_expansion_pitch: { colorClass: 'success' },
  view_dashboard: { colorClass: DEFAULT_COLOR_CLASS },
};

export const FooterToken = {
  COUNT: '{count}',
  TOTAL: '{total}',
};

export const AgentUserField = {
  ID: 'id',
  NAME: 'name',
  EMAIL: 'email',
  CLIENT_GROUP_ID: 'client_group_id',
};

export const WINDOW_OPEN_FEATURES = 'noopener,noreferrer';

export const SalesDashboardRoute = {
  SALES_DASHBOARD: 'sales/dashboard',
};

export const SalesDashboardPathName = {
  SALES_DASHBOARD: 'sales-dashboard:vue',
};
